import React from "react";
import style from "./QuestDanxuan.module.scss";
import { Icon, Radio } from "antd";

interface QuestDanxuanProps {
    index: number;
    correct: boolean;
    trunk: string;
    answers: {
        answerId: number;
        content: string;
        isRight: "0" | "1";
        isChoose: "0" | "1";
    }[];
}

export default function QuestDanxuan({
    index,
    correct,
    trunk,
    answers
}: QuestDanxuanProps) {
    const selected = answers.find(item => item.isChoose === "1");
    const selectedValue = selected ? selected.answerId : "";

    return (
        <div className={style.root}>
            <div className={style.content}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${index + 1}.${trunk}`
                    }}
                />
            </div>

            <Radio.Group className={style.RadioGroup} value={selectedValue}>
                {answers.map(item => (
                    <Radio
                        key={item.answerId}
                        className={style.radio}
                        value={item.answerId}>
                        {/* {item.content} */}
                        <div
                            className={style.inlinblock}
                            dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                    </Radio>
                ))}
            </Radio.Group>

            {correct ? (
                <div className={`${style.result} ${style.right} globalISROOTS`}>
                    <Icon type="check" /> 正确
                </div>
            ) : (
                <div className={`${style.result} ${style.wrong} globalISROOTS`}>
                    <Icon type="close" /> 错误
                </div>
            )}
        </div>
    );
}
